import type { ComponentProps } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { cn } from "../../lib/utils";

type AvatarUser = { name?: string; picture?: string };
export function UserAvatar({ user, className = "" }: { user?: AvatarUser; className?: string }) {
  return (
    <Avatar
      className={cn(
        "inline-flex size-8 flex-none border-0 bg-accent",
        !user && "border border-dashed border-border bg-transparent",
        className,
      )}
    >
      <AvatarImage
        src={user?.picture || undefined}
        alt=""
        referrerPolicy="no-referrer"
        className="object-cover"
      />
      <AvatarFallback
        className={cn(
          "bg-accent [font-family:system-ui,sans-serif] text-xs leading-none font-semibold text-zinc-200",
          !user && "bg-transparent",
        )}
      >
        {user ? user.name?.trim().slice(0, 1).toUpperCase() || "?" : null}
      </AvatarFallback>
    </Avatar>
  );
}

// Each avatar after the first overlaps the previous one, and an avatar with
// another one after it is cut out where that one overlaps it.
export function OverlappingUserAvatar({
  user,
  index,
  hasNext = false,
  ...props
}: ComponentProps<"span"> & {
  user?: AvatarUser;
  index: number;
  hasNext?: boolean;
}) {
  return (
    <span
      title={user?.name}
      className={cn(
        "relative z-1 inline-flex",
        index > 0 && "-ml-2",
        hasNext && "[mask:radial-gradient(circle_18px_at_40px_50%,transparent_97%,black_100%)]",
      )}
      {...props}
    >
      <UserAvatar user={user} />
    </span>
  );
}
